"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRedirectUrlByLanguageCode = exports.getValidLanguageCode = exports.getLanguageCodeFromHost = exports.getDomainLanguageCodeFromHost = void 0;
const weglot_1 = require("root/src/shared/constants/weglot");
const languageCodes_1 = require("root/src/shared/constants/languageCodes");
const domainName_1 = __importDefault(require("root/src/aws/util/domainName"));
const getDomainLanguageCodeFromHost = (host) => {
    if (!host) {
        return languageCodes_1.languageCodes.en;
    }
    const languageCode = host.split('.').at(0);
    const validCode = (0, exports.getValidLanguageCode)(languageCode);
    if (validCode === languageCodes_1.languageCodes.en) {
        return null;
    }
    return validCode;
};
exports.getDomainLanguageCodeFromHost = getDomainLanguageCodeFromHost;
const getLanguageCodeFromHost = (host) => {
    if (!host) {
        return languageCodes_1.languageCodes.en;
    }
    const languageCode = host.split('.').at(0);
    return (0, exports.getValidLanguageCode)(languageCode);
};
exports.getLanguageCodeFromHost = getLanguageCodeFromHost;
const getValidLanguageCode = (languageCode, defaultLanguageCode = languageCodes_1.languageCodes.en) => {
    var _a;
    return (_a = weglot_1.Weglot.languageCodes.find(code => languageCode === code)) !== null && _a !== void 0 ? _a : defaultLanguageCode;
};
exports.getValidLanguageCode = getValidLanguageCode;
const getRedirectUrlByLanguageCode = (path, languageCode) => {
    return `https://${languageCode}.${domainName_1.default}${path}`;
};
exports.getRedirectUrlByLanguageCode = getRedirectUrlByLanguageCode;
